import axios from 'axios';

const TOKEN_KEY = '_admin_token';

const api = axios.create({
    baseURL: '/api',
    timeout: 30000, // 30s timeout — admin endpoints talk to VPN panel which can be slow
    withCredentials: true, // Send HttpOnly cookies automatically
});

// Request interceptor: attach Bearer token as fallback when HttpOnly cookie may not work
// (e.g. self-signed SSL cert, Cloudflare proxy stripping cookies, SameSite issues)
api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem(TOKEN_KEY);
    if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor: handle 401 redirects
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const isLoginPage = window.location.pathname === '/login';
            const isLoginRequest = error.config?.url?.includes('/token');
            if (!isLoginPage && !isLoginRequest) {
                // Clear stored token and redirect to login
                sessionStorage.removeItem(TOKEN_KEY);
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

// Helper: store token after successful login
export function setAuthToken(token) {
    if (token) {
        sessionStorage.setItem(TOKEN_KEY, token);
    }
}

// Helper: clear token on logout
export function clearAuthToken() {
    sessionStorage.removeItem(TOKEN_KEY);
}

export default api;
